export const YT_MUTED = 'YT_MUTED';
export const YT_VOLUME = 'YT_VOLUME';
